/*!

=========================================================
* Black Dashboard React v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";
import axios from "axios";

// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";
import { logoutUser } from "actions/AuthAction";
import { useHistory } from "react-router-dom";
import { API_SOISALAK } from "utils";

function Dashboard(props) {
  const [bigChartData, setbigChartData] = React.useState("data1");

  const [tabelPerangkatDaerah, setTabelPerangkatDaerah] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [label, setLabel] = useState([]);
  const [dataGraph1, setDataGraph1] = useState({ label: [], dataGraph: [] });
  const [dataGraph2, setDataGraph2] = useState({ label: [], dataGraph: [] });
  const [dataGraph3, setDataGraph3] = useState({ label: [], dataGraph: [] });
  const [penggunaSoiSalak, setPenggunaSoiSalak] = useState([]);
  const [currentUser, setCurrentUser] = useState("");
  const [notif, setNotif] = useState([]);
  const [idDinas, setIdDinas] = useState(null);
  const [statusUser, setStatusUser] = useState(null);
  const [perangkatdaerah, setPerangkatdaerah] = useState(null);
  const [tahun, setTahun] = useState(new Date().getFullYear());
  const [statistikBulanan, setStatistikBulanan] = useState([]);
  const [loadingStatistik, setLoadingStatistik] = useState(false);
  const [loadingTemuanTerakhir, setLoadingTemuanTerakhir] = useState(false);
  const [loadingTindakLanjutTerakhir, setLoadingTindakLanjutTerakhir] =
    useState(false);
  const history = useHistory();

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      setIdDinas(JSON.parse(user).idDinas);
      setStatusUser(JSON.parse(user).status);
      setPerangkatdaerah(JSON.parse(user).perangkatdaerah);
    } else {
      logoutUser(history);
    }
  }, []);

  // Fungsi untuk mengambil data temuan terakhir
  const ambilTemuanTerakhir = async () => {
    setLoadingTemuanTerakhir(true);
    try {
      let url;
      if (statusUser == 3) {
        // Admin - ambil data semua dinas
        url = `${API_SOISALAK}/temuan`;
      } else {
        // User dinas - ambil data dinas tertentu
        url = `${API_SOISALAK}/temuan/dinastemuan/${idDinas}`;
      }

      const response = await axios.get(url);
      if (response.data.success) {
        setNotif(response.data.data);
      }
    } catch (error) {
      console.error("Error mengambil data temuan terakhir:", error);
      setNotif([]);
    }
    setLoadingTemuanTerakhir(false);
  };

  // Fungsi untuk mengambil data tindak lanjut terakhir yang terverifikasi
  const ambilTindakLanjutTerakhir = async () => {
    setLoadingTindakLanjutTerakhir(true);
    try {
      let url;
      if (statusUser == 3) {
        // Admin - ambil data semua dinas
        url = `${API_SOISALAK}/tindak-lanjut/terakhir/verified`;
      } else {
        // User dinas - ambil data dinas tertentu
        url = `${API_SOISALAK}/tindak-lanjut/dinas/${idDinas}/terakhir/verified`;
      }

      const response = await axios.get(url);
      if (response.data.success) {
        setPenggunaSoiSalak(response.data.data);
      }
    } catch (error) {
      console.error("Error mengambil data tindak lanjut terakhir:", error);
      setPenggunaSoiSalak([]);
    }
    setLoadingTindakLanjutTerakhir(false);
  };

  // Fungsi untuk mengambil data statistik per bulan
  const ambilStatistikBulanan = async () => {
    setLoadingStatistik(true);
    try {
      let url;
      if (statusUser == 3) {
        // Admin - ambil data semua dinas
        url = `${API_SOISALAK}/tindak-lanjut/tahun/${tahun}/bulan`;
      } else {
        // User dinas - ambil data dinas tertentu
        url = `${API_SOISALAK}/tindak-lanjut/dinas/${idDinas}/tahun/${tahun}/bulan`;
      }

      const response = await axios.get(url);
      if (response.data.success) {
        setStatistikBulanan(response.data.data);
      }
    } catch (error) {
      console.error("Error mengambil data statistik bulanan:", error);
      setStatistikBulanan([]);
    }
    setLoadingStatistik(false);
  };

  // useEffect untuk mengambil data statistik ketika tahun berubah
  useEffect(() => {
    if (tahun && (statusUser === 3 || idDinas)) {
      ambilStatistikBulanan();
    }
  }, [tahun, statusUser, idDinas]);

  // useEffect untuk mengambil data temuan terakhir dan tindak lanjut terakhir
  useEffect(() => {
    if (statusUser === 3 || idDinas) {
      ambilTemuanTerakhir();
      ambilTindakLanjutTerakhir();
    }
  }, [statusUser, idDinas]);

  useEffect(() => {
    // Data dummy untuk efektifitas
    const dummyEfektifitas = [
      { singk: "Dinas Kesehatan", efektifitas: 85 },
      { singk: "Dinas Pendidikan", efektifitas: 78 },
      { singk: "Dinas Sosial", efektifitas: 92 },
      { singk: "Dinas Lingkungan", efektifitas: 67 },
      { singk: "Dinas Perhubungan", efektifitas: 88 },
      { singk: "Dinas Pariwisata", efektifitas: 75 },
      { singk: "Dinas Pertanian", efektifitas: 81 },
      { singk: "Dinas Perikanan", efektifitas: 73 },
      { singk: "Dinas Perindustrian", efektifitas: 89 },
      { singk: "Dinas Kependudukan", efektifitas: 94 },
    ];

    // Set data dummy untuk efektifitas saja
    setTabelPerangkatDaerah(dummyEfektifitas);

    // Generate data grafik dari statistik bulanan
    if (statistikBulanan.length > 0) {
      // Data untuk grafik temuan per bulan
      const labelTemuan = statistikBulanan.map((item) => item.nama_bulan);
      const dataTemuan = statistikBulanan.map((item) => item.jumlah_temuan);
      setDataGraph1({ label: labelTemuan, dataGraph: dataTemuan });

      // Data untuk grafik tindak lanjut per bulan
      const dataTindakLanjut = statistikBulanan.map(
        (item) => item.jumlah_tindak_lanjut
      );
      setDataGraph2({ label: labelTemuan, dataGraph: dataTindakLanjut });

      // Data untuk grafik persentase
      const dataPersentase = statistikBulanan.map((item) => {
        if (item.jumlah_temuan === 0) return 0;
        return Math.round(
          (item.jumlah_tindak_lanjut / item.jumlah_temuan) * 100
        );
      });
      setDataGraph3({ label: labelTemuan, dataGraph: dataPersentase });
    }
  }, [statistikBulanan]);

  const setBgChartData = (name) => {
    setbigChartData(name);
  };

  let chart1_2_options = {
    maintainAspectRatio: false,
    legend: {
      display: true,
      position: "top",
      labels: {
        fontColor: "#9a9a9a",
        usePointStyle: true,
        padding: 20,
      },
    },
    tooltips: {
      backgroundColor: "#f5f5f5",
      titleFontColor: "#333",
      bodyFontColor: "#666",
      bodySpacing: 4,
      xPadding: 12,
      mode: "nearest",
      intersect: 0,
      position: "nearest",
    },
    responsive: true,
    scales: {
      yAxes: [
        {
          barPercentage: 1.6,
          gridLines: {
            drawBorder: false,
            color: "rgba(29,140,248,0.0)",
            zeroLineColor: "transparent",
          },
          ticks: {
            suggestedMin: 0,
            suggestedMax: 10,
            padding: 20,
            fontColor: "#9a9a9a",
            callback: function (value, index, values) {
              return value;
            },
          },
        },
      ],
      xAxes: [
        {
          barPercentage: 1.6,
          gridLines: {
            drawBorder: false,
            color: "rgba(29,140,248,0.1)",
            zeroLineColor: "transparent",
          },
          ticks: {
            padding: 20,
            fontColor: "#9a9a9a",
            maxRotation: 45,
            minRotation: 45,
          },
        },
      ],
    },
  };

  let chartExample1 = {
    data1: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke1 = ctx.createLinearGradient(0, 230, 0, 50);
      gradientStroke1.addColorStop(1, "rgba(29,140,248,0.2)");
      gradientStroke1.addColorStop(0.4, "rgba(29,140,248,0.0)");
      gradientStroke1.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

      let gradientStroke2 = ctx.createLinearGradient(0, 230, 0, 50);
      gradientStroke2.addColorStop(1, "rgba(255,99,132,0.2)");
      gradientStroke2.addColorStop(0.4, "rgba(255,99,132,0.0)");
      gradientStroke2.addColorStop(0, "rgba(255,99,132,0)"); //red colors

      return {
        labels: dataGraph1.label,
        datasets: [
          {
            label: "Jumlah Temuan",
            fill: true,
            backgroundColor: gradientStroke1,
            borderColor: "#1f8ef1",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#1f8ef1",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#1f8ef1",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: dataGraph1.dataGraph,
          },
          {
            label: "Jumlah Tindak Lanjut (Verified)",
            fill: true,
            backgroundColor: gradientStroke2,
            borderColor: "#ff6384",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#ff6384",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#ff6384",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: dataGraph2.dataGraph,
          },
        ],
      };
    },
    data2: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke1 = ctx.createLinearGradient(0, 230, 0, 50);
      gradientStroke1.addColorStop(1, "rgba(29,140,248,0.2)");
      gradientStroke1.addColorStop(0.4, "rgba(29,140,248,0.0)");
      gradientStroke1.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

      let gradientStroke2 = ctx.createLinearGradient(0, 230, 0, 50);
      gradientStroke2.addColorStop(1, "rgba(255,99,132,0.2)");
      gradientStroke2.addColorStop(0.4, "rgba(255,99,132,0.0)");
      gradientStroke2.addColorStop(0, "rgba(255,99,132,0)"); //red colors

      return {
        labels: dataGraph2.label,
        datasets: [
          {
            label: "Jumlah Temuan",
            fill: true,
            backgroundColor: gradientStroke1,
            borderColor: "#1f8ef1",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#1f8ef1",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#1f8ef1",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: dataGraph1.dataGraph,
          },
          {
            label: "Jumlah Tindak Lanjut (Verified)",
            fill: true,
            backgroundColor: gradientStroke2,
            borderColor: "#ff6384",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#ff6384",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#ff6384",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: dataGraph2.dataGraph,
          },
        ],
      };
    },
    data3: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);
      gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
      gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
      gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

      return {
        labels: dataGraph3.label,
        datasets: [
          {
            label: "Persentase Tindak Lanjut dari Temuan (%)",
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: "#1f8ef1",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#1f8ef1",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#1f8ef1",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: dataGraph3.dataGraph,
          },
        ],
      };
    },
    options: chart1_2_options,
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("id-ID", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const formatDateTime = (dateTimeString) => {
    const date = new Date(dateTimeString);
    return date.toLocaleString("id-ID", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <>
      <div className="content">
        {/* Filter Tahun */}
        <Row style={{ marginBottom: 20 }}>
          <Col md={3}>
            <FormGroup>
              <Label for="tahunFilter">Filter Tahun:</Label>
              <Input
                type="select"
                id="tahunFilter"
                value={tahun}
                onChange={(e) => setTahun(e.target.value)}
                style={{ color: "black" }}
              >
                {Array.from({ length: 6 }, (_, i) => {
                  const year = new Date().getFullYear() - 1 + i;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </Input>
            </FormGroup>
          </Col>
          <Col md={9}>
            <div style={{ marginTop: 30 }}>
              {loadingStatistik ? (
                <span className="text-muted">Loading data...</span>
              ) : (
                <span className="text-muted"></span>
              )}
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs="12">
            <Card className="card-chart">
              <CardHeader>
                <Row>
                  <Col className="text-left" sm="6">
                    <h5 className="card-category">
                      Statistik Temuan dan Tindak Lanjut Per Bulan{" "}
                      {statusUser == 3
                        ? "Semua Perangkat Daerah"
                        : perangkatdaerah}
                    </h5>
                    <CardTitle tag="h2">Dashboard {tahun}</CardTitle>
                  </Col>
                  <Col sm="6">
                    <ButtonGroup
                      className="btn-group-toggle float-right"
                      data-toggle="buttons"
                    >
                      <Button
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data1",
                        })}
                        color="info"
                        id="0"
                        size="sm"
                        onClick={() => setBgChartData("data1")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Temuan & Tindak Lanjut
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-single-02" />
                        </span>
                      </Button>
                      <Button
                        color="info"
                        id="1"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data2",
                        })}
                        onClick={() => setBgChartData("data2")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Perbandingan
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-gift-2" />
                        </span>
                      </Button>
                      <Button
                        color="info"
                        id="2"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data3",
                        })}
                        onClick={() => setBgChartData("data3")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Persentase
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-tap-02" />
                        </span>
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={chartExample1[bigChartData]}
                    options={chart1_2_options}
                  />
                </div>
                {/* Legend tambahan */}
                <div
                  className="chart-legend"
                  style={{ marginTop: 20, textAlign: "center" }}
                >
                  <Row>
                    <Col md={6}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            width: 20,
                            height: 3,
                            backgroundColor: "#1f8ef1",
                            marginRight: 10,
                          }}
                        ></div>
                        <span style={{ color: "#9a9a9a", fontSize: "14px" }}>
                          Jumlah Temuan
                        </span>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            width: 20,
                            height: 3,
                            backgroundColor: "#ff6384",
                            marginRight: 10,
                          }}
                        ></div>
                        <span style={{ color: "#9a9a9a", fontSize: "14px" }}>
                          Jumlah Tindak Lanjut (Verified)
                        </span>
                      </div>
                    </Col>
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col lg="6" md="12">
            <Card className="card-tasks">
              <CardHeader>
                <h6 className="title d-inline">Temuan Terakhir (10)</h6>
                <p className="card-category d-inline"> terbaru</p>
                <UncontrolledDropdown>
                  <DropdownToggle
                    caret
                    className="btn-icon"
                    color="link"
                    data-toggle="dropdown"
                    type="button"
                  >
                    <i className="tim-icons icon-settings-gear-63" />
                  </DropdownToggle>
                  <DropdownMenu aria-labelledby="dropdownMenuLink" right>
                    <DropdownItem
                      href="#pablo"
                      onClick={(e) => {
                        e.preventDefault();
                        ambilTemuanTerakhir();
                      }}
                    >
                      Refresh
                    </DropdownItem>
                    <DropdownItem
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      Lihat Semua
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </CardHeader>
              <CardBody>
                <div className="table-full-width table-responsive">
                  {loadingTemuanTerakhir ? (
                    <div className="text-center py-4">
                      <span className="text-muted">Loading data temuan...</span>
                    </div>
                  ) : notif.length === 0 ? (
                    <div className="text-center py-4">
                      <span className="text-muted">
                        Tidak ada data temuan terbaru
                      </span>
                    </div>
                  ) : (
                    <Table>
                      <tbody>
                        {notif.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <FormGroup check>
                                <Label check>
                                  <Input defaultValue="" type="checkbox" />
                                  <span className="form-check-sign">
                                    <span className="check" />
                                  </span>
                                </Label>
                              </FormGroup>
                            </td>
                            <td>
                              <p className="title">
                                {item.jenis_temuan || "Temuan"}
                              </p>
                              <p className="text-muted">
                                {item.nama_dinas +
                                  " - " +
                                  formatDate(item.tanggalTemuan)}
                              </p>
                              <p className="text-muted">
                                Status:{" "}
                                {item.status_verifikasi === "1"
                                  ? "Terverifikasi"
                                  : "Belum Terverifikasi"}
                              </p>
                              <p className="text-muted">
                                {item.deskripsi_temuan || "Tidak ada deskripsi"}
                              </p>
                            </td>
                            <td className="td-actions text-right">
                              <Button
                                color="link"
                                id={`tooltip${index}`}
                                title=""
                                type="button"
                              >
                                <i className="tim-icons icon-pencil" />
                              </Button>
                              <UncontrolledTooltip
                                delay={0}
                                target={`tooltip${index}`}
                                placement="right"
                              >
                                Lihat Detail
                              </UncontrolledTooltip>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg="6" md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Tindak Lanjut Terverifikasi (10)</CardTitle>
                <p className="card-category"> terakhir</p>
                <UncontrolledDropdown>
                  <DropdownToggle
                    caret
                    className="btn-icon"
                    color="link"
                    data-toggle="dropdown"
                    type="button"
                  >
                    <i className="tim-icons icon-settings-gear-63" />
                  </DropdownToggle>
                  <DropdownMenu aria-labelledby="dropdownMenuLink" right>
                    <DropdownItem
                      href="#pablo"
                      onClick={(e) => {
                        e.preventDefault();
                        ambilTindakLanjutTerakhir();
                      }}
                    >
                      Refresh
                    </DropdownItem>
                    <DropdownItem
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      Lihat Semua
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </CardHeader>
              <CardBody>
                {loadingTindakLanjutTerakhir ? (
                  <div className="text-center py-4">
                    <span className="text-muted">
                      Loading data tindak lanjut...
                    </span>
                  </div>
                ) : penggunaSoiSalak.length === 0 ? (
                  <div className="text-center py-4">
                    <span className="text-muted">
                      Tidak ada data tindak lanjut terverifikasi
                    </span>
                  </div>
                ) : (
                  <Table className="tablesorter" responsive>
                    <thead className="text-primary">
                      <tr>
                        <th>Tanggal</th>
                        <th>Dinas</th>
                        <th>Status</th>
                        <th className="text-center">Temuan</th>
                      </tr>
                    </thead>
                    <tbody>
                      {penggunaSoiSalak &&
                        penggunaSoiSalak.map((item, index) => (
                          <tr key={index}>
                            <td>{formatDate(item.tanggalTL)}</td>
                            <td>{item.nama_dinas}</td>
                            <td>
                              <span
                                className={`badge badge-${
                                  item.status_verifikasi === "1"
                                    ? "success"
                                    : "warning"
                                }`}
                              >
                                {item.status_verifikasi === "1"
                                  ? "Terverifikasi"
                                  : "Pending"}
                              </span>
                            </td>
                            <td className="text-center">
                              {item.jenis_temuan || "Temuan"}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Dashboard;
